import React, {useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './LanguageSelector.scss';

import flagPL from '../assets/images/pl_flag.gif';
import flagEN from '../assets/images/uk_flag.gif';
import {changeLanguage} from "../store/actions/languageActions";

const selector = state => {
    const { language } = state;
    return {
        locale: language.locale
    }
};

const LanguageSelector = props => {
    const { locale } = useSelector(selector);
    const dispatch = useDispatch();

    useEffect(() => {
        if(localStorage.getItem('lang')) {
            dispatch(changeLanguage(localStorage.getItem('lang')))
        } else {
            localStorage.setItem('lang', 'pl');
            dispatch(changeLanguage('pl'))
        }
    },[])

    const changeLang = lang => {
        dispatch(changeLanguage(lang))
        localStorage.setItem('lang',lang)
    }

    return (
        <div className='LanguageSelector'>
            <div
                className={locale === 'pl' ? 'languageItem languageItem--active' : 'languageItem'}
                onClick={() => changeLang('pl')}
            >
                <img src={flagPL} alt='language flag'/>
            </div>
            <div
                className={locale === 'en' ? 'languageItem languageItem--active' : 'languageItem'}
                onClick={() => changeLang('en')}
            >
                <img src={flagEN} alt='language flag'/>
            </div>
        </div>
    );
};

export default LanguageSelector;
